import React, { useState, Fragment, useRef, useEffect } from 'react';
// import Counties from './Counties';
import GeoMapTooltip from '../GeoMapTooltip';
import Markets from './Markets';
import Regions from './Regions';
import States from './States';
import Counties from './Counties';
import ZipCode from './ZipCode.jsx';
import { MATCH_VIEW } from '../GeoMapConstant';

const USHeatMapChart = ({
  view,
  data,
  geoLabel,
  indexLabel,
  setIsIframeLoaded,
  iframeRef,
}) => {
  const [toolTipData, setToolTipData] = useState({});
  const toolTipRef = useRef(null);
  const matchView = MATCH_VIEW.find(element => element === view);

  const removeLabelsToMap = id => {
    // if (geoLabel && indexLabel) return;
    const removeLable = Array.from(document.getElementsByClassName(id));
    if (removeLable.length > 0) {
      removeLable.forEach(item => {
        item.remove();
      });
    }
  };

  const addLabelsToMap = labelType => {
    data.forEach(item => {
      const label = document.getElementById(item.id);
      if (label) {
        const bbox = label.getBBox();
        const x = bbox.x + bbox.width / 2;
        const y = bbox.y + bbox.height / 2;
        if (labelType === 'geo-label') {
          const textElem = document.createElementNS(label.namespaceURI, 'text');
          textElem.setAttribute('x', x);
          textElem.setAttribute('y', y);
          textElem.setAttribute('text-anchor', 'middle');
          textElem.classList.add('label-heat-map');
          textElem.style.fontWeight = 600;
          textElem.textContent =
            'state_name' in label.dataset === true
              ? label.dataset.state_name
              : label.dataset.stusps;
          label.after(textElem);
        }
        if (labelType === 'index-label') {
          const textElem = document.createElementNS(label.namespaceURI, 'text');
          textElem.setAttribute('x', x);
          textElem.setAttribute('y', y + 15);
          textElem.setAttribute('text-anchor', 'middle');
          textElem.classList.add('index-heat-map');
          textElem.style.fontWeight = 600;
          textElem.textContent = item.i;
          label.after(textElem);
        }
      }
    });
  };

  useEffect(() => {
    removeLabelsToMap('index-heat-map');
    removeLabelsToMap('label-heat-map');
    if (geoLabel && matchView) addLabelsToMap('geo-label');
    if (indexLabel && matchView) addLabelsToMap('index-label');
    if (!indexLabel) removeLabelsToMap('index-heat-map');
    if (!geoLabel) removeLabelsToMap('label-heat-map');
  }, [geoLabel, indexLabel, data]);

  const onMouseMove = evt => {
    if (!data.length || evt.target.classList.contains('white')) {
      toolTipRef.current.style.display = 'none';
      return;
    }

    const _data = data.find(item => item.id == evt.target.id);
    const offsetX = 'nativeEvent' in evt ? evt.nativeEvent.offsetX : evt.offsetX;
    const offsetY = 'nativeEvent' in evt ? evt.nativeEvent.offsetY : evt.offsetY;

    setToolTipData(_data);
    toolTipRef.current.style.display = 'block';
    toolTipRef.current.style.top = `${
      offsetY - toolTipRef.current.offsetHeight - 10
    }px`;
    toolTipRef.current.style.left = `${offsetX}px`;
  };

  const onMouseLeave = () => {
    toolTipRef.current.style.display = 'none';
  };

  const renderMap = (currentMap) => {
    const mapsComponent = {
      'Census Region': <Regions onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} />,
      'State': <States onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} />,
      'Market': <Markets onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} />,
      'County': <Counties onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} />,
      'Zip Code': (
        <ZipCode
          onMouseMove={onMouseMove}
          onMouseLeave={onMouseLeave}
          setIsIframeLoaded={setIsIframeLoaded}
          iframeRef={iframeRef}
        />
      ),
    };
    return mapsComponent[currentMap];
  };

  return (
    <Fragment>
      {renderMap(view)}
      {toolTipData && (
        <GeoMapTooltip toolTipRef={toolTipRef} toolTipData={toolTipData} />
      )}
    </Fragment>
  );
};

export default USHeatMapChart;
